import CssBaseline from '@mui/material/CssBaseline';
import { ThemeProvider } from '@mui/material/styles';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import ReactDOM from 'react-dom';
import { HelmetProvider } from 'react-helmet-async';
import './amplify';
import { App } from './app-root';
import { AuthProvider } from './contexts/auth-context';
import { materialTheme } from './theme';
import { installRequestMonitor } from './utils/request-monitor';

// Feed the connection banner and the no-access screen from every API call
installRequestMonitor();

// Create a client
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Retry once, but not 4xx: the API answered, and asking again only
      // doubles the error logs and delays the message
      retry: (failureCount, error) => {
        const status = (error as { response?: { status?: number } })?.response
          ?.status;
        return failureCount < 1 && !(status && status >= 400 && status < 500);
      },
      refetchOnWindowFocus: false,
    },
  },
});

ReactDOM.render(
  <ThemeProvider theme={materialTheme}>
    <CssBaseline />

    <QueryClientProvider client={queryClient}>
      <HelmetProvider>
        <AuthProvider>
          <App />
        </AuthProvider>
      </HelmetProvider>
    </QueryClientProvider>
  </ThemeProvider>,
  document.getElementById('root'),
);
